import styled from 'styled-components';
import { palettePrimaryContrast, palettePrimaryMain } from '../../../assets/variables';

export const Nav = styled.nav`
  display: flex;
  position: fixed;
  top: 49px;
  max-width: 0px;
  overflow-x: hidden;
  color: ${palettePrimaryContrast};
  background-color: ${palettePrimaryMain};
  height: fit-content;
  z-index: 2;
  flex-direction: column;

  .search-input {
    width: calc(100% - 55px);
    margin-left: 10px;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid ${palettePrimaryContrast};
    outline: none;
    color: ${palettePrimaryContrast};
  }

  .title-container {
    height: 50px;
  }

  .section {
    cursor: pointer;
  }

  .sub-section-list {
    max-height: 0;
    transition: max-height 0.5s ease-out;
    overflow-y: hidden;

    .sub-section {
      padding-left: 10px;
      padding-top: 2.5px;
      display: block;
    }
  }

  .show-sub-section-list {
    max-height: 500px;
    transition: max-height 0.5s ease-in;
  }

  .title {
    padding: 0 5px 5px;
    border-bottom: 1px solid;
    margin: 0 !important;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    max-height: calc(100vh - 49px);
  }

  &.side-menu-active {
    max-width: calc(100vw - 50px);
    max-height: calc(100vh - 50px);
    display: flex;
    justify-content: center;
  }

  // Overrides
  .RUIText-base {
    margin-left: 10px;
    width: calc(100% - 45px);
  }

  .RUIDropdown-anchor {
    width: 100%;
  }

  .RUISelect-base {
    .RUIInput-input {
      border: none;
      color: ${palettePrimaryContrast};
    }
  }

  .RUIInput-input {
    color: ${palettePrimaryContrast};
    &:active:not(:disabled),
    &:focus:not(:disabled) {
      border-color: ${palettePrimaryContrast};
    }
  }
  .RUISelect-icon {
    width: 24px;
  }
`;
